import { render, staticRenderFns } from "./GeologicalMonitor.vue?vue&type=template&id=16b95622&scoped=true&"
import script from "./GeologicalMonitor.vue?vue&type=script&lang=js&"
export * from "./GeologicalMonitor.vue?vue&type=script&lang=js&"
import style0 from "./GeologicalMonitor.vue?vue&type=style&index=0&id=16b95622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b95622",
  null
  
)

export default component.exports